import ArtList from './ArtList';

export default ArtList;
